/**
 * Formats seconds into HH:mm:ss format
 * @param {number} seconds - Total number of seconds
 * @returns {string} Formatted time string in HH:mm:ss format
 */
export const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

/**
 * Calculates remaining time in seconds from a given end time
 * @param {string} endTime - ISO string of the end time
 * @returns {number} Remaining time in seconds
 */
export const calculateRemainingTime = (endTime) => {
    const now = new Date().getTime();
    const end = new Date(endTime).getTime();
    const remaining = Math.floor((end - now) / 1000);
    return remaining > 0 ? remaining : 0;
};

/**
 * Converts duration string (HH:mm:ss) to seconds
 * @param {string} duration - Duration string in HH:mm:ss format
 * @returns {number} Duration in seconds
 */
export const durationToSeconds = (duration) => {
    if (!duration) return 0;
    
    // Handle string format "HH:mm:ss"
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + seconds;
};

/**
 * Calculates end time based on current time and duration
 * @param {number} durationInSeconds - Duration in seconds
 * @returns {Date} End time as Date object
 */
export const calculateEndTime = (durationInSeconds) => {
    return Date.now() + (durationInSeconds * 1000);
};

/**
 * Formats date with Arabic month name
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string with Arabic month
 */
export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const arabicMonths = {
        'January': 'يناير',
        'February': 'فبراير',
        'March': 'مارس',
        'April': 'أبريل',
        'May': 'مايو',
        'June': 'يونيو',
        'July': 'يوليو',
        'August': 'أغسطس',
        'September': 'سبتمبر',
        'October': 'أكتوبر',
        'November': 'نوفمبر',
        'December': 'ديسمبر'
    };

    const month = date.toLocaleString('en-US', { month: 'long' });
    const arabicMonth = arabicMonths[month];

    return `${date.getDate()} ${arabicMonth} ${date.getFullYear()} ${date.toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit'
    })}`;
};

/**
 * Formats date without time in DD/MM/YYYY format
 * @param {string} dateString - ISO date string
 * @returns {string} Formatted date string
 */
export const formatDateSimple = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
}; 